import { memo, useEffect, useState } from 'react';
import Constant from '@/common/constant/Constant';
import './ListTicketChatMessage.css';
import Utils from '@/common/utils/utils';
import LoadingMessage from './LoadingMessage';
import {
    buildFreeMessage,
    buildGetAllListKnowledgeOfListTagField,
    buildListTagFieldMessage,
    buildListTicketMessage,
    buildMessageSuggestUsingAI,
    buildQAFormLiveChat,
    buildQAFormMessage,
    buildTheEndMessage,
    createMessageList,
    getDrillDownDataForChatBot,
    getListTicketAfterSelectedOption,
    getListTicketOfListTag,
    getListTicketOfSelectedTagField,
    postMessage,
} from './handler/ChatBoxHandler';
import { cloneDeep } from 'lodash';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { v4 as uuidv4} from 'uuid';
function MessageLoadListTagField({
    message,
    subDomain,
    projectId,
    chatbotSettings,
    messages,
    setMessages,
    supportThreadIdState,
    affiliationOrganization,
    isModePreview,
    listCategories,
    setListTagFieldOfSelectedCategory,
    setListTagFieldId,
    setListKnowledgeTicketId,
    setFilterPublicKnowledge,
    setListSelectedItemOfSession,
    setListTagFieldSelected,
    handleWhenRenderTagFieldPriority,
    setListTicketIdBeforeFilterTagField,
    setQueryGetListKnowledgeBase,
    usingAI,
    listTagFieldSelected,
    listTagItemSelected,
    listTagFieldSkip,
    enableListTicket,
    resolvedMessages
}) {
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessageContent, setFreeMessageContent] = useState(isModePreview ? previewSetting.freeMsg : chatbotSettings.freeMsg);
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(isModePreview ? previewSetting.maxNumberAnswer : chatbotSettings.maxNumberAnswer );
    const [maxHitTicket,setMaxHitTicket] = useState(isModePreview ? previewSetting.numberHitKnowledgeTicket : chatbotSettings.numberHitKnowledgeTicket);
    const [messageState, setMessagesState] = useState(message)
    
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    useEffect(() => {
        if (!isModePreview) {
            setFreeMessageContent(chatbotSettings.freeMsg);
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
            setMaxHitTicket(chatbotSettings.numberHitKnowledgeTicket)
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.freeMsg !== freeMessageContent) {
                
                setFreeMessageContent(previewSetting.freeMsg);
            }

            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }

            if(previewSetting.numberHitKnowledgeTicket !== maxHitTicket){
                setMaxHitTicket(previewSetting.numberHitKnowledgeTicket)
            }
        }
    }, [previewSetting]);

    useEffect(() => {
        let idOfCategory = messageState.idOfCategory;

        const categoryDetail = listCategories.find(category => {
            return category.id === idOfCategory;
        });

        const viewStructure = categoryDetail.viewStructure;

        const listTagFiledId = categoryDetail.listTagFiledId;
        let settingTagFiledOfCategory = categoryDetail?.chatBotCategorySetting?.tagFields;

        const viewId = categoryDetail?.chatBotCategorySetting?.viewId;

        getDrillDownDataForChatBot(
            projectId,
            subDomain,
            viewStructure,
            affiliationOrganization,
            viewId
        ).then(response => {
            setListSelectedItemOfSession([])
            
            let tagFiledList = []
            response?.tagFieldList?.forEach(tagField => {

                if (listTagFiledId.includes(tagField.id)) {
                    const settingTagFiled = settingTagFiledOfCategory.find(setting => {
                        return setting.id === tagField.id;
                    });

                    if (!Utils.isEmptyObject(settingTagFiled) && !listTagFieldSkip?.includes(tagField.id)) {
                        tagField.priority = settingTagFiled?.priority;
                        tagField.order = settingTagFiled.order;

                        tagFiledList.push(tagField);
                    }
                }
            });

            let messagesClone = cloneDeep(messages).slice(0,-1);

            tagFiledList = Utils.sortListTagFieldOfCategory(cloneDeep(tagFiledList));

            setListTagFieldOfSelectedCategory(tagFiledList);

            // check quantity knowledge ticket of all tag field
            let ticketListId = getListTicketOfListTag(tagFiledList);

            let newMessagesList = []

            if(ticketListId.length === 0) {
                let settings = isModePreview ? previewSetting : chatbotSettings;
                switch(settings?.actionWhenNotResolve) {
                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                        let idQALivechat = `qaform_${uuidv4()}`
                        let dataLiveChat = {
                            isDefault: false,
                            idQA: idQALivechat,
                            categoryIdSelected: idOfCategory,
                            formQASystem: message.formQASystem,
                        };

                        const newMessages = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                        postMessage(
                            newMessages,
                            supportThreadIdState,
                            affiliationOrganization,
                            false,
                            isModePreview,
                            idQALivechat
                        );
                        setMessages(prev => [...prev.slice(0,-1), newMessages]);
                        setFilterPublicKnowledge({
                            view: viewId,
                            tagFieldSelected: []
                        });
                        setQueryGetListKnowledgeBase({
                            view: viewId,
                            tagFieldSelected: []
                        })
                        setListKnowledgeTicketId([...ticketListId]);
                        break;
        
                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                        let idQA = `qaform_${uuidv4()}`
                        let data = {
                            isDefault: false,
                            idQA: idQA,
                            data: {
                                categoryIdSelected: idOfCategory,
                                formQASystem: messageState.formQASystem,
                            }
                        };

                        const newMessage = buildQAFormMessage(data, resolvedMessages);
                        postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview, idQA);
                        setMessages(prev => [...prev.slice(0,-1), newMessage]);
                        setFilterPublicKnowledge({
                            view: viewId,
                            tagFieldSelected: []
                        });

                        setQueryGetListKnowledgeBase({
                            view: viewId,
                            tagFieldSelected: []
                        });
                        setListKnowledgeTicketId([...ticketListId]);
                        break;
        
                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                    default:
                        newMessagesList.push(buildFreeMessage(freeMessageContent,newMessagesList.length));
                        newMessagesList.push(buildTheEndMessage(newMessagesList.length, messageState.formQASystem, resolvedMessages));
            
                        createMessageList(newMessagesList,supportThreadIdState,affiliationOrganization,isModePreview)
                        setMessages([...messagesClone, ...newMessagesList]);
                        setFilterPublicKnowledge({
                            view: viewId,
                            tagFieldSelected: []
                        });

                        setQueryGetListKnowledgeBase({
                            view: viewId,
                            tagFieldSelected: []
                        });

                        setListKnowledgeTicketId([...ticketListId]);
                        break;
                }
                return ;
            }

            //NOTE: Expect get all ticket according to views
            // let filter = buildGetAllListKnowledgeOfListTagField(tagFiledList);
            // filterObjectClone.tagFieldSelected.push(filter);

            let filterObjectClone = {
                view: viewId,
                tagFieldSelected: []
            };
            
            setQueryGetListKnowledgeBase(filterObjectClone);
            //NOTE: First thread get list ticket
            if (
                response.totalTicketInList <= maxHitTicket && enableListTicket
            ){  
                const newMessageForUser = enableListTicket ? buildListTicketMessage(filterObjectClone.tagFieldSelected, newMessagesList.length, [], usingAI) : buildMessageSuggestUsingAI(messages.length, resolvedMessages);
                newMessagesList.push(newMessageForUser);
                
                createMessageList(newMessagesList,supportThreadIdState,affiliationOrganization,isModePreview)
                setMessages([...messagesClone, ...newMessagesList]);
                setFilterPublicKnowledge(filterObjectClone);
                setListKnowledgeTicketId([...ticketListId]);
                return;
            }

            let listTagFieldIdOfCategory = tagFiledList?.map((tagField) => {
                return tagField.id
            });
            setListTagFieldId(listTagFieldIdOfCategory)

            let newMessage = {};
            let firstTagFiled = tagFiledList[0]

            if(firstTagFiled?.priority|| tagFiledList.length === 1){
                setListTagFieldSelected(prev => [...prev,firstTagFiled.id]);
                const listTicketIdOfField = getListTicketOfSelectedTagField(firstTagFiled);
                setListTicketIdBeforeFilterTagField([...ticketListId]);
                const listTicketAfterSelectedField = getListTicketAfterSelectedOption(
                    ticketListId,
                    listTicketIdOfField
                );
                newMessage = handleWhenRenderTagFieldPriority(firstTagFiled,listTicketAfterSelectedField,true, [])
            }else{
                newMessage  = buildListTagFieldMessage(tagFiledList, [], 1, true, usingAI, listTagFieldSelected, listTagItemSelected);
                setFilterPublicKnowledge({
                    view: viewId,
                    tagFieldSelected: []
                });
            }
            messagesClone.push(newMessage);
            createMessageList([newMessage],supportThreadIdState,affiliationOrganization,isModePreview)
            setMessages([...messagesClone]);

        });
    }, []);
    return (
        <div className='message-text'>
            <LoadingMessage />
        </div>
    );
}

export default memo(MessageLoadListTagField);
